import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function useApiAlert() {
    const { t } = useTranslation();
    const [message, setMessage] = useState('');
    const [show, setShow] = useState(false);
    const [details, setDetails] = useState(null);
    const alertRef = useRef(null);

    useEffect(() => {
        if (!show) return;
        if (alertRef && alertRef.current && typeof alertRef.current.scrollIntoView === 'function') {
            alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        const timer = setTimeout(() => setShow(false), 5000);
        return () => clearTimeout(timer);
    }, [show]);

    // pageKey: optional string to indicate which page/context is showing the error
    const showError = (msg, detailsData = null, pageKey = '') => {
        setMessage(msg || t('common.error') || 'Error');
        setDetails({ data: detailsData, page: pageKey });
        setShow(true);
    };

    const showSuccess = (msg) => {
        setMessage(msg || t('common.success') || 'Success');
        setDetails(null);
        setShow(true);
    };

    const renderDetails = () => {
        if (!details || !details.data) return null;
        const payload = details.data;
        const page = details.page || '';
        if (Array.isArray(payload) && payload.length > 0) {
            const isDepositLike = payload.every(d => d && (d.depositCode || d.amount || d.branchName));
            // only render deposit-like list when page explicitly matches 'depositor'
            if (page === 'depositor' && isDepositLike) {
                return (
                    <div style={{ textAlign: 'left', marginTop: '12px' }}>
                        <p><strong>Items ({payload.length}):</strong></p>
                        <ul style={{ listStyle: 'none', paddingLeft: 0, marginBottom: 0 }}>
                            {payload.map((item, idx) => (
                                <li key={idx} style={{ padding: '8px', background: '#f8f9fa', margin: '5px 0', borderRadius: '4px' }}>
                                    {item.depositCode && <div><strong>{item.depositCode}</strong></div>}
                                    <div>
                                        {item.amount != null ? `Deposit of ₹${Number(item.amount || 0).toLocaleString('en-IN')}` : null}
                                        {item.status ? ` is ${String(item.status).toLowerCase()}` : null}
                                        {item.branchName ? ` at ${item.branchName}` : null}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            }
            return <pre className="mt-2 mb-0">{JSON.stringify(payload, null, 2)}</pre>;
        }
        return <pre className="mt-2 mb-0">{JSON.stringify(payload, null, 2)}</pre>;
    };

    const ApiAlert = () => {
        if (!show) return null;
        return (
            <Row ref={alertRef}>
                <Col xl={12}>
                    <div className="alert alert-danger" role="alert">
                        <button type="button" className="btn-close" onClick={() => setShow(false)}></button>
                        <strong>{t('common.error')}: </strong> {message}
                        {renderDetails()}
                    </div>
                </Col>
            </Row>
        );
    };

    return { message, show, details, showError, showSuccess, setShow, ApiAlert };
}
